import React from "react";
import Disclosure from "../Disclosure";
// Footer component of the application
const Footer = () => {
  // Function to get the current year
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  return (
    <footer className="bg-dark-purple text-white py-10 relative z-10">
      <div className="container 2xl:max-w-[1164px] xl:max-w-[1240px] mx-auto lg:px-5 md:px-8 px-5">
        <p className="text-center sm:text-xl text-lg md:text-2xl font-roboto font-normal text-white leading-100">
          © {getCurrentYear()} Dunce, All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
